import React from 'react';

import { CHECKOUT_PAGE_TEXT } from '../../constants/CheckoutPageText';
import PromoCheckoutBanner from '../promoComponents/PromoCheckoutBanner';

import { PaymentMethods } from './AccountUtils';
import DisplayPayInfo from './DisplayPayInfo';
import FeeMessage from './FeeMessage';
import PromoCodeSection from './PromoCodeSection';
import SlashedPrice from './SlashedPrice';


const FanzoneSubscriptionForm = (props) => {
  const {
    anchorShortUrl,
    anchorToSubscribe,
    isGift,
    isItem,
    showPromoInput,
    shouldShowPromoCheckoutBanner,
    activeCampaign,
    anchorSubscriptionPrograms,
    activeProgram,
    handlePackageChange,
    displayTimeUnit,
    calculateRecurringAmmount,
    onSubmitClick,
    epochAvailable,
    selectedPaymentMethod,
    paysafeAvailable,
    onPaymentMethodChange,
    oneClickPaymentData,
    shouldAnimate,
    setAnimationState,
    isFanzoneSubscriptionPage,
    isPromoPage,
    promoCodeInfo,
    setPromoCodeInfo,
    fetchPackages,
    listOfActiveCampaigns,
    renderFeeMessage,
    hasPromoInURL,
    oldPrices,
    fanzoneCampaign,
  } = props;
  const buttonIsDisabled = !((activeProgram.id && selectedPaymentMethod) || !epochAvailable || !paysafeAvailable);
  const animationClass = shouldAnimate ? 'animate-prices' : '';
  const shouldRenderComponent = anchorToSubscribe && !isItem && !isGift && !fanzoneCampaign;

  if (!shouldRenderComponent) {
    return null;
  }

  return (
    <form
      action="/account/submission"
      id="package_selection_form"
      method="GET"
    >
      <div id="package_selection_zone">
        <div>
          <PromoCheckoutBanner
            checkoutImage={activeCampaign.checkoutImage}
            shouldShowPromoCheckoutBanner={shouldShowPromoCheckoutBanner}
            showPromoInput={!showPromoInput}
          />
          <h3 className="caps">{CHECKOUT_PAGE_TEXT.FANZONE_SUBSCRIPTION_HEADER}</h3>

          <div>
            {anchorSubscriptionPrograms.map((program, index) => (
              <React.Fragment key={program.id}>
                <label
                  className={`package ${animationClass} ${program.id === activeProgram.id ? 'selected-package white' : ''
                    }`}
                >
                  <input
                    checked={program.id === activeProgram.id}
                    className="package-radio"
                    type="radio"
                    value={program.id}
                    onChange={handlePackageChange}
                  />
                  <span />
                  <p className={'montserrat package-timespan'}>
                    {program.details ? (
                      <span className="fw-600">
                        {displayTimeUnit(program)}
                        <DisplayPayInfo
                          activeCampaign={activeCampaign}
                          hasPromoInURL={hasPromoInURL}
                          isPromoPage={isPromoPage}
                          program={program}
                          promoCodeInfo={promoCodeInfo}
                        />
                      </span>
                    ) : (
                      <>
                        Lifetime
                        <small>Billed once. Never rebills.</small>
                      </>
                    )}
                  </p>
                  <p className="montserrat package-amount-custom pull-right">
                    {program.details ? (
                      <span>
                        {calculateRecurringAmmount(program)}
                      </span>
                    ) : (
                      <span>
                        {program.currency.symbol}{program.amount}
                      </span>
                    )}
                    <SlashedPrice oldPrices={oldPrices} program={program} index={index} />
                  </p>
                </label>
                <FeeMessage
                  shouldRenderFeeMessage={renderFeeMessage}
                />
                <p className="montserrat strong">
                  {CHECKOUT_PAGE_TEXT.FANZONE_SUBSCRIPTION_DESCRIPTION}
                </p>
              </React.Fragment>
            ))}
            <PaymentMethods
              epochAvailable={epochAvailable}
              oneClickPaymentData={oneClickPaymentData}
              paysafeAvailable={paysafeAvailable}
              selectedPaymentMethod={selectedPaymentMethod}
              onPaymentMethodChange={onPaymentMethodChange}
            />
          </div>
        </div>
      </div>
      <PromoCodeSection
        anchorShortUrl={anchorShortUrl}
        fetchPackages={fetchPackages}
        hasPromoInURL={hasPromoInURL}
        isFanzoneSubscriptionPage={isFanzoneSubscriptionPage}
        listOfActiveCampaigns={listOfActiveCampaigns}
        setAnimationState={setAnimationState}
        setPromoCodeInfo={setPromoCodeInfo}
        showPromoInput={showPromoInput}
      />
      <div className="cta-button-container">
        <button
          className="btn btn-primary btn-xxl btn-block montserrat caps continue-button"
          disabled={buttonIsDisabled}
          type="submit"
          onClick={onSubmitClick}
        >
          CONTINUE
        </button>
      </div>
    </form>
  );
};

export default FanzoneSubscriptionForm;
